export var SenderType;
(function (SenderType) {
    SenderType["USER"] = "user";
    SenderType["BOT"] = "bot";
    SenderType["OPERATOR"] = "operator";
})(SenderType || (SenderType = {}));
export var DisplayNameStatus;
(function (DisplayNameStatus) {
    DisplayNameStatus["PENDING"] = "pending";
    DisplayNameStatus["APPROVED"] = "approved";
    DisplayNameStatus["DISAPPROVED"] = "disapproved";
})(DisplayNameStatus || (DisplayNameStatus = {}));
